import { Element } from "@xmpp/xml"
import { ExtractedMetadata, MessageDisplayType } from "@/reducers/messagesSlice"
import MessageParser from "./messageParser"

export default class ExtractedMetadataParser {
  static parse(
    stanza: Element,
    timestamp?: string,
  ): ExtractedMetadata | undefined {
    const extractedMetadataNode = stanza.getChild("extracted-metadata")

    if (!extractedMetadataNode) return

    // Parse metadata from item children
    const metadata: Record<string, string> = {}
    const itemNodes = extractedMetadataNode.getChildren("item")

    itemNodes.forEach((item) => {
      const key = item.attrs.key
      const value = item.text()
      if (key) {
        metadata[key] = value || ""
      }
    })

    return {
      id: MessageParser.id(stanza, false),
      to: stanza.attrs.to,
      from: stanza.attrs.from,
      messageId: extractedMetadataNode.attrs["message_id"],
      timestamp: timestamp || new Date().toISOString(),
      displayType: MessageDisplayType.ExtractedMetadata,
      documentType: extractedMetadataNode.attrs["document_type"],
      type: stanza.attrs.type,
      data: Object.keys(metadata).length > 0 ? metadata : undefined,
      blurry: extractedMetadataNode.attrs["blurry"] === "true",
      remarks: extractedMetadataNode.attrs["remarks"] || undefined,
    } as ExtractedMetadata
  }
}
